import { Injectable } from '@angular/core';

export type HighlightType = 'WEEKLY' | 'DAILY' | 'MONTHLY' | 'QUARTERLY';

export interface HeadlinePageConfig {
  key: string;
  route: string;
  // title: string;
  // highlightText: string;
  // highlightType: HighlightType;
}

@Injectable({
  providedIn: 'root'
})
export class HeadlinePageService {

  constructor() { }

  private readonly PAGE_CONFIG: HeadlinePageConfig[] = [
    {
      key: 'monthly_report_1',
      route: '/dashboard/monthly-report-1'
    },
    {
      key: 'monthly_report_2',
      route: '/dashboard/monthly-report-2'
    },
    {
      key: 'social_platform',
      route: '/dashboard/social-platform'
    },
    {
      key: 'seo_stats',
      route: '/dashboard/seo-stats'
    },
    {
      key: 'campaign_stats',
      route: '/dashboard/campaign-stats'
    },
    {
      key: 'industry_categorization',
      route: '/dashboard/industry-categorization'
    },
    {
      key: 'seo_overview',
      route: '/dashboard/seo-overview'
    },
    {
      key: 'business',
      route: '/visionboard/business'
    },
    {
      key: 'contracts',
      route: '/visionboard/contracts'
    },
    {
      key: 'daily_cron_payments',
      route: '/cron-jobs/daily-cron-payments'
    },
    {
      key: 'tab_overview',
      route: '/cron-jobs/arrangement-cron?tab=overview'
    },
    {
      key: 'tab_trends',
      route: '/cron-jobs/arrangement-cron?tab=trends'
    },
    {
      key: 'admin_performance',
      route: '/cron-jobs/arrangement-cron?tab=admin-performance'
    },
    {
      key: 'cron_payments',
      route: '/cron-jobs/cron-payments'
    },
    {
      key: 'training_analytics',
      route: '/dashboard/training-analytics'
    }
  ];

  // 🔹 Get all configs
  getAllConfigs(): HeadlinePageConfig[] {
    return this.PAGE_CONFIG;
  }

  // 🔹 Get config by route
  getConfigByRoute(route: string | undefined): HeadlinePageConfig | undefined {
    return this.PAGE_CONFIG.find(config => config.route === route);
  }

  // 🔹 Get config by key
  getConfigByKey(key: string): HeadlinePageConfig | undefined {
    return this.PAGE_CONFIG.find(config => config.key === key);
  }
}